import { Component, OnInit,  ElementRef, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { FrontService } from '../front.service';
import { Menu } from '../../models/menu.model';
import { ClientService } from '../../services/client.service';
import { Client } from '../../models/client.model';
import { Subscription } from 'rxjs/Subscription';
import { trim } from 'jquery';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Auth } from '../../models/auth.model';
import { Icon } from '../../models/icon.model';
import { IconService } from '../../services/icon.service';
import { User } from '../../models/user.model';
import { UserService } from '../../services/user.service';

import { MyDesktopService } from '../../services/mydesktop.service';
import { VaultService } from '../../services/vault.service';
import { Subject } from 'rxjs';

declare var $: any;
declare var jQuery: any;
declare var introJs: any;
declare var swal: any;
declare var _bugHerd: any;

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit, OnDestroy, AfterViewInit {
  destroy$: Subject<boolean> = new Subject;
  loading = false;
  menus: Menu[] = [];
  client: Client;
  title = 'Settings';
  logo_link = '';
  private color = '#127bdc';
  private colorMainHeading = '#127bdc';
  private colorSubHeading = '#127bdc';
  private colorIcon = '#127bdc';

  icons: Icon[] = [];

  imagePickerId;

  logoForm: FormGroup;
  formFontColor: FormGroup;
  linksForm: FormGroup;
  agencyForm: FormGroup;

  is_colorpicker_open = false;
  current_picker: string;


  public items: Array<string> = ['Arial', 'Lato'];

  private value: any = {};
  private _disabledV = '0';
  private disabled = false;

  authUser: Auth;
  user = {
    ID: 21,
    client_id: 5,
    name: 'John Doe',
    photo: 'assets/img/user_photo.jpg',
    email: 'johndoe@websiteblue.com',
    mobile: '+6112345678',
    telephone: '1234 5678',
    fax: '9876 5432'
  };

  users: User[];

  defaultTab = 'logo';

  supportLink = '';

  lockFields = [];

  @ViewChild('canvasEl') canvasElem: ElementRef;

  constructor(
    public frontService: FrontService,
    private clientService: ClientService,
    private iconService: IconService,
    private userService: UserService,
    private mydesktopService: MyDesktopService,
    private vaultService: VaultService
  ) { }

  ngOnInit() {
    this.supportLink = this.frontService.supportLink;

    this.authUser = this.frontService.authService.auth;

    this.user = {
      ID: this.authUser.user.agent_id,
      client_id: this.authUser.client.ID,
      name: this.authUser.user.firstname + ' ' + this.authUser.user.firstname,
      photo: this.authUser.user.photo,
      email: this.authUser.user.email,
      mobile: this.authUser.user.mobile,
      telephone: this.authUser.user.telephone,
      fax: this.authUser.user.fax
    };

    if (this.authUser.is_admin || this.authUser.is_master) {
      this.userService.httpGetUsers({'client_id': this.user.client_id });
    }

    this.userService.usersChanged
    .takeUntil(this.destroy$)
    .subscribe(
      (users: any) => {
        if ( typeof users !== 'undefined' && users.status === 'success' ) {
          this.loading = false;

          if ( users.count > 0 ) {
            this.users = users.data.sort(function(a, b) {
              const x = a.firstname.toLowerCase();
              const y = b.firstname.toLowerCase();
              return x < y ? -1 : x > y ? 1 : 0;
            });
          }
        }
      }
    );

    this.mydesktopService.syncAgents
    .takeUntil(this.destroy$)
    .subscribe(
      (agents: any) => {
        if (typeof agents !== 'undefined' && typeof agents.sync !== 'undefined') {
          swal({
            title: 'Syncing Agent List',
            timer: 2000,
            onOpen: function () {
              swal.showLoading ();
            }
          }).then(
            function () {},
            // handling the promise rejection
            function (dismiss) {
              if (dismiss === 'timer') {
                location.reload();
              }
            }
          );
        }
      }
    );

    this.frontService.loadMenu(this.menus);

    this.client = this.authUser.client;

    if (this.client.is_account_master === 0 && this.client.group.setting_menu_link === 1) {
      this.defaultTab = 'link';
    }
    if (this.client.is_account_master === 0 && this.client.group.setting_menu_icon === 1) {
      this.defaultTab = 'icon';
    }
    if (this.client.is_account_master === 0 && this.client.group.setting_menu_font === 1) {
      this.defaultTab = 'font';
    }
    if (this.client.is_account_master === 0 && this.client.group.setting_menu_color === 1) {
      this.defaultTab = 'color';
    }
    if (this.client.is_account_master === 0 && this.client.group.setting_menu_logo === 1) {
      this.defaultTab = 'logo';
    }

    this.iconService.httpGetIcons();

    this.clientService.clientLink
    .takeUntil(this.destroy$)
    .subscribe(
      (client: Client) => {
        this.loading = false;
        if (typeof client.ID !== 'undefined') {
          this.client = client;
          this.frontService.authService.updateAuthCookieField('client', JSON.stringify(client));
        }
      }
    );

    this.clientService.clientLogo
    .takeUntil(this.destroy$)
    .subscribe(
      (client: Client) => {
        this.loading = false;
        this.logo_link = client.primary_logo;
        this.displayImageColorPicker(9);
        if (typeof client.ID !== 'undefined') {
          this.client = client;
          this.frontService.authService.updateAuthCookieField('client', JSON.stringify(client));
        }
      }
    );

    this.clientService.clientColor
    .takeUntil(this.destroy$)
    .subscribe(
      (client: Client) => {
        this.loading = false;

        if (typeof client.ID !== 'undefined') {
          this.client = client;
          this.frontService.authService.updateAuthCookieField('client', JSON.stringify(client));
        }
      }
    );

    this.clientService.clientIcon
    .takeUntil(this.destroy$)
    .subscribe(
      (client: Client) => {
        this.loading = false;

        if (typeof client.ID !== 'undefined') {
          this.client = client;
          this.frontService.authService.updateAuthCookieField('client', JSON.stringify(client));
        }
      }
    );

    this.iconService.iconsChanged
    .takeUntil(this.destroy$)
    .subscribe(
      (icons: Icon[]) => {
        this.icons = icons;
        this.iconPicker();
      }
    );

    this.clientService.clientLockFields
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.loading = false;
          this.lockFields = response.data;
        }
      }
    );

    this.clientService.clientOperation
    .takeUntil(this.destroy$)
    .subscribe(
      (client: Client) => {
        if ( typeof client.ID !== 'undefined'  ) {
          this.loading = false;

          swal({
            type: 'success',
            title: 'Changes has been saved',
            showConfirmButton: false,
            timer: 1500,
            allowEscapeKey: false,
            allowOutsideClick: false
          });

          setTimeout(() => {
            location.reload();
          }, 1000);
        }
      }
    );

    this.vaultService.onVaultSyncAgent
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success') {
          swal({
            title: 'Syncing Agent List',
            timer: 2000,
            onOpen: function () {
              swal.showLoading ();
            }
          }).then(
            function () {},
            // handling the promise rejection
            function (dismiss) {
              if (dismiss === 'timer') {
                location.reload();
              }
            }
          );
        }
      }
    );

    this.logo_link = this.client.primary_logo;

    jQuery('.asColorpicker1').asColorPicker('val', this.client.color_1);
    jQuery('.asColorpicker2').asColorPicker('val', this.client.color_2);
    jQuery('.asColorpicker3').asColorPicker('val', this.client.color_3);
    jQuery('.asColorpicker4').asColorPicker('val', this.client.color_4);
    jQuery('.asColorpicker5').asColorPicker('val', this.client.color_5);
    jQuery('.asColorpicker6').asColorPicker('val', this.client.color_6);
    jQuery('.asColorpicker7').asColorPicker('val', this.client.color_7);
    jQuery('.asColorpicker8').asColorPicker('val', this.client.color_8);

    this.initfontColorForm();
    this.initlinksForm();
    this.initlinksFormEdit();

    this.initAgencyForm();

    this.displayImageColorPicker(9);
  }

  iconPicker() {
    const $this = this;
    setTimeout(
      () => {
        jQuery('.icon-primary-bed').click(function() {
          jQuery('.icon-primary-bed').parent().removeClass('icon-holder-active');
          jQuery(this).parent().addClass('icon-holder-active');
          const icon = {primary_icon_bed: jQuery(this).attr('src')};
          $this.clientService.httpPutIcon($this.user.client_id, icon);
          $this.loading = true;
        });

        jQuery('.icon-primary-bath').click(function() {
          jQuery('.icon-primary-bath').parent().removeClass('icon-holder-active');
          jQuery(this).parent().addClass('icon-holder-active');
          const icon = {primary_icon_bath: jQuery(this).attr('src')};
          $this.clientService.httpPutIcon($this.user.client_id, icon);
          $this.loading = true;
        });

        jQuery('.icon-primary-car').click(function() {
          jQuery('.icon-primary-car').parent().removeClass('icon-holder-active');
          jQuery(this).parent().addClass('icon-holder-active');
          const icon = {primary_icon_car: jQuery(this).attr('src')};
          $this.clientService.httpPutIcon($this.user.client_id, icon);
          $this.loading = true;
        });

        jQuery('.icon-secondary-bed').click(function() {
          jQuery('.icon-secondary-bed').parent().removeClass('icon-holder-active');
          jQuery(this).parent().addClass('icon-holder-active');
          const icon = {secondary_icon_bed: jQuery(this).attr('src')};
          $this.clientService.httpPutIcon($this.user.client_id, icon);
          $this.loading = true;
        });

        jQuery('.icon-secondary-bath').click(function() {
            jQuery('.icon-secondary-bath').parent().removeClass('icon-holder-active');
            jQuery(this).parent().addClass('icon-holder-active');
            const icon = {secondary_icon_bath: jQuery(this).attr('src')};
            $this.clientService.httpPutIcon($this.user.client_id, icon);
            $this.loading = true;
        });

        jQuery('.icon-secondary-car').click(function() {
            jQuery('.icon-secondary-car').parent().removeClass('icon-holder-active');
            jQuery(this).parent().addClass('icon-holder-active');
            const icon = {secondary_icon_car: jQuery(this).attr('src')};
            $this.clientService.httpPutIcon($this.user.client_id, icon);
            $this.loading = true;
        });
      }, 1000
    );
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  ngAfterViewInit() {
    this.initializeColorPicker();
    if ( localStorage.getItem('first_settings') === '1' ) {
      this.startTour();

      // set setting tour to 0
      localStorage.setItem('first_settings', '0');
    }
  }

  public selected(value: any): void {}

  public removed(value: any): void {}

  public typed(value: any): void {}

  public refreshValue(value: any): void {
    this.value = value;
  }

  initializeColorPicker() {
    jQuery('.asColorpicker1').asColorPicker();
    jQuery('.asColorpicker2').asColorPicker();
    jQuery('.asColorpicker3').asColorPicker();
    jQuery('.asColorpicker4').asColorPicker();
    jQuery('.asColorpicker5').asColorPicker();
    jQuery('.asColorpicker6').asColorPicker();
    jQuery('.asColorpicker7').asColorPicker();
    jQuery('.asColorpicker8').asColorPicker();

    jQuery('.asColorpicker1, .asColorpicker2, .asColorpicker3, .asColorpicker4, .asColorpicker5').on('asColorPicker::change', function (e) {
      colorChange(jQuery(this).attr('data-picker'));
    });

    function colorChange(box) {
      const new_color = jQuery('.asColorpicker' + box).val();
      jQuery('#box_color_' + box).css('background', new_color);
    }

    function readURL(input) {
      if (input.files && input.files[0]) {
          let reader = new FileReader();
          reader.onload = function (e) {
            const target: any = e.target;
            const content: string = target.result;

            const image_placement = jQuery(input).attr('data-action');
            jQuery(image_placement).attr('src', content);
          };

          reader.readAsDataURL(input.files[0]);
      }
    }

    jQuery('#image-primary').change(function(){
        readURL(this);
    });

    jQuery('#image-secondary').change(function(){
      readURL(this);
    });
  }

  uploadLogo(event: Event) {
    const target: HTMLInputElement = event.target as HTMLInputElement;

    for (let i = 0; i < target.files.length; i++) {
      this.clientService.httpPutLogo(this.authUser.client.ID, 'primary', target.files[i]);
    }
    this.loading = true;
  }

  uploadSecondaryLogo(event: Event) {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    for (let i = 0; i < target.files.length; i++) {
      this.clientService.httpPutLogo(this.authUser.client.ID, 'secondary', target.files[i]);
    }
    this.loading = true;
  }

  private initfontColorForm() {
    this.formFontColor = new FormGroup({
      'color_1': new FormControl(''),
      'color_2': new FormControl(''),
      'color_3': new FormControl(''),
      'color_4': new FormControl(''),
      'color_5': new FormControl(''),
      'color_6': new FormControl(''),
      'color_7': new FormControl(''),
      'color_8': new FormControl(''),
      'font_family': new FormControl(''),
    });
  }

  private initlinksForm() {
    this.linksForm = new FormGroup({
      'link_website': new FormControl(''),
      'link_short_website': new FormControl(''),
      'link_buy': new FormControl(''),
      'link_sell': new FormControl(''),
      'link_rent': new FormControl(''),
      'link_unsubscribe': new FormControl(''),
      'link_home': new FormControl(''),
      'link_about': new FormControl(''),
      'link_careers': new FormControl(''),
      'link_blog': new FormControl(''),
      'link_facebook': new FormControl(''),
      'link_twitter': new FormControl(''),
      'link_youtube': new FormControl(''),
      'link_instagram': new FormControl(''),
      'link_linkedin': new FormControl(''),
      'link_pinterest': new FormControl(''),
      'link_gplus': new FormControl(''),
      'link_ratemyagent': new FormControl(''),
      'link_contact': new FormControl(''),
      'disclaimer_email': new FormControl(''),
      'disclaimer_print': new FormControl(''),
      'legal_1': new FormControl(''),
      'legal_2': new FormControl(''),
      'legal_3': new FormControl('')
    });
  }

  private initlinksFormEdit() {
    this.linksForm.patchValue({
      'link_website': this.client.link_website,
      'link_short_website': this.client.link_short_website,
      'link_buy': this.client.link_buy,
      'link_sell': this.client.link_sell,
      'link_rent': this.client.link_rent,
      'link_unsubscribe': this.client.link_unsubscribe,
      'link_home': this.client.link_home,
      'link_about': this.client.link_about,
      'link_careers': this.client.link_careers,
      'link_blog': this.client.link_blog,
      'link_facebook': this.client.link_facebook,
      'link_twitter': this.client.link_twitter,
      'link_youtube': this.client.link_youtube,
      'link_instagram': this.client.link_instagram,
      'link_linkedin': this.client.link_linkedin,
      'link_pinterest': this.client.link_pinterest,
      'link_gplus': this.client.link_gplus,
      'link_ratemyagent': this.client.link_ratemyagent,
      'link_contact': this.client.link_contact,
      'disclaimer_email': this.client.disclaimer_email,
      'disclaimer_print': this.client.disclaimer_print,
      'legal_1': this.client.legal_1,
      'legal_2': this.client.legal_2,
      'legal_3': this.client.legal_3
    });
  }

  private initAgencyForm() {
    this.agencyForm = new FormGroup({
      'franchise_name': new FormControl(this.client.franchise_name),
      'company_name': new FormControl(this.client.company_name),
      'name': new FormControl(this.client.name),
      'street': new FormControl(this.client.street),
      'suburb': new FormControl(this.client.suburb),
      'state': new FormControl(this.client.state),
      'postcode': new FormControl(this.client.postcode),
      'country': new FormControl(this.client.country),
      'phone': new FormControl(this.client.phone),
      'fax': new FormControl(this.client.fax),
      'email': new FormControl(this.client.email)
    });
  }

  private checkUrl() {
    const links = [jQuery('#form_website').val(), jQuery('#form_buy').val(), jQuery('#form_sell').val(),jQuery('#form_rent').val(), 
                  jQuery('#form_contact').val(), jQuery('#form_home').val(), jQuery('#form_about').val(), 
                  jQuery('#form_careers').val(), jQuery('#form_blog').val(), jQuery('#form_fb').val(), jQuery('#form_tw').val(),
                  jQuery('#form_yt').val(), jQuery('#form_ig').val(), jQuery('#form_linkedin').val(), jQuery('#form_gplus').val(), 
                  jQuery('#form_ratemyagent').val()];

    for (let i = 0; links.length > i; i++) {
      if (!this.validateUrl(links[i])) {
        return false;
      }
    }

    return true;
  }

  saveLinks() {
    if (!this.checkUrl()) {
      return false;
    }

    this.linksForm.patchValue({
      'link_website': this.linksForm.get('link_website').value,
      'link_buy': this.linksForm.get('link_buy').value,
      'link_sell': this.linksForm.get('link_sell').value,
      'link_rent': this.linksForm.get('link_rent').value,
      'link_unsubscribe': this.linksForm.get('link_unsubscribe').value,
      'link_home': this.linksForm.get('link_home').value,
      'link_about': this.linksForm.get('link_about').value,
      'link_careers': this.linksForm.get('link_careers').value,
      'link_blog': this.linksForm.get('link_blog').value,
      'link_facebook': this.linksForm.get('link_facebook').value,
      'link_twitter': this.linksForm.get('link_twitter').value,
      'link_youtube': this.linksForm.get('link_youtube').value,
      'link_instagram': this.linksForm.get('link_instagram').value,
      'link_linkedin': this.linksForm.get('link_linkedin').value,
      'link_pinterest': this.linksForm.get('link_pinterest').value,
      'link_gplus': this.linksForm.get('link_gplus').value,
      'link_ratemyagent': this.linksForm.get('link_ratemyagent').value,
      'disclaimer_email': this.linksForm.get('disclaimer_email').value,
      'disclaimer_print': this.linksForm.get('disclaimer_print').value,
      'link_contact': this.linksForm.get('link_contact').value
    });
    const linksValue = this.linksForm.value;


    this.clientService.httpPutLinks(this.user.client_id, linksValue);
    this.loading = true;
  }

  saveColor() {
    const color_1 = jQuery('.asColorpicker1').val();
    const color_2 = jQuery('.asColorpicker2').val();
    const color_3 = jQuery('.asColorpicker3').val();
    const color_4 = jQuery('.asColorpicker4').val();
    const color_5 = jQuery('.asColorpicker5').val();
    const color_6 = jQuery('.asColorpicker6').val();
    const color_7 = jQuery('.asColorpicker7').val();
    const color_8 = jQuery('.asColorpicker8').val();

    this.formFontColor.patchValue({
      'color_1': (color_1.includes('#') ? color_1 : '#' + color_1),
      'color_2': (color_2.includes('#') ? color_2 : '#' + color_2),
      'color_3': (color_3.includes('#') ? color_3 : '#' + color_3),
      'color_4': (color_4.includes('#') ? color_4 : '#' + color_4),
      'color_5': (color_5.includes('#') ? color_5 : '#' + color_5),
      'color_6': (color_6.includes('#') ? color_6 : '#' + color_6),
      'color_7': (color_7.includes('#') ? color_7 : '#' + color_7),
      'color_8': (color_8.includes('#') ? color_8 : '#' + color_8)
    });

    const fontValue = this.formFontColor.value;

    this.clientService.httpPutColor(this.user.client_id, fontValue);
    this.loading = true;
  }

  displayImageColorPicker(id) {
    let image = new Image;

    let canvas = this.canvasElem.nativeElement;
    let ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    image.crossOrigin = 'Anonymous';

    image.onload = function() {
      canvas.width = 500;
      canvas.height = 370;

      const w = image.width;
      const h = image.height;

      const sizes = scalePreserveAspectRatio(w, h, canvas.width, canvas.height);

      ctx.drawImage(image, 0, 0, w * sizes, h * sizes);
    };

    const default_logo = this.logo_link;

    if (typeof default_logo === 'undefined' || default_logo === '') {
      jQuery('#error_msg_image').css('display', 'block');
    } else {
      image.src = default_logo;
    }

    function scalePreserveAspectRatio(imgW, imgH, maxW, maxH) {
      return(Math.min((maxW / imgW), (maxH / imgH)));
    }

    jQuery(canvas).unbind('click').click(function(e) {
      const canvasOffset = jQuery(canvas).offset();
      const canvasX = Math.floor(e.pageX - canvasOffset.left);
      const canvasY = Math.floor(e.pageY - canvasOffset.top);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imageData.data;
      const pixelRedIndex = ((canvasY - 1) * (imageData.width * 4)) + ((canvasX - 1) * 4);
      const pixelcolor = 'rgba(' + pixels[pixelRedIndex] + ', ' + pixels[pixelRedIndex+1] + ', ' + pixels[pixelRedIndex+2] + ', ' + pixels[pixelRedIndex+3] + ')';

      jQuery('#rVal').val(pixels[pixelRedIndex]);
      jQuery('#gVal').val(pixels[pixelRedIndex + 1]);
      jQuery('#bVal').val(pixels[pixelRedIndex + 2]);
      jQuery('#rgbVal').val(pixels[pixelRedIndex] + ', ' + pixels[pixelRedIndex + 1] + ', ' + pixels[pixelRedIndex + 2]);
      jQuery('#rgbaVal').val(pixels[pixelRedIndex] + ', ' + pixels[pixelRedIndex+1] + ', ' + pixels[pixelRedIndex+2] + ', ' + pixels[pixelRedIndex+3]);
      jQuery('#hexVal').val('#' + toHex(pixels[pixelRedIndex]) + toHex(pixels[pixelRedIndex + 1]) + toHex(pixels[pixelRedIndex + 2]));

      jQuery('#preview').css('background', pixelcolor);

      jQuery('.asColorpicker' + id).val('#' + toHex(pixels[pixelRedIndex]) + toHex(pixels[pixelRedIndex+1]) + toHex(pixels[pixelRedIndex+2]));
      jQuery('.asColorpicker' + id).asColorPicker('val', '#' + toHex(pixels[pixelRedIndex]) + toHex(pixels[pixelRedIndex+1]) + toHex(pixels[pixelRedIndex+2]));

    });

    function toHex(n) {
      let hex = n.toString(16);
      while (hex.length < 2) {hex = '0' + hex; }
      return hex;
    }
    if (id !== 9) {
      jQuery('#modalImageCpicker').modal('show');
    }
  }

  onFeedback() {
    swal({
      title: 'We would love to hear from you about the new MyDesign',
      imageUrl: 'http://mydesign3.wbclients.com/mydesign/assets/images/message-square.svg',
      imageWidth: 300,
      imageHeight: 100,
      showConfirmButton: false,
      html: '<p>Please choose to provide either Feedback or log a Support Ticket</p>' +
      '<a class="btn btn-success btn-bh-feedback">Send Feedback</a> &nbsp; <a href="' + this.supportLink+ '" target="_blank" class="btn btn-info btn-support-log">Log Support Ticket</a>'
      } );

      jQuery('.btn-bh-feedback').click(function() {
        swal.close();
        _bugHerd.win.bugherd.applicationView.anonymousbar.toggleOptions();
      });
  }

  isGroupVisible(fieldData: number = 0) {
    if ( this.authUser.is_master || (this.authUser.is_admin && fieldData === 1) ) {
      return true;
    }
    return false;
  }

  validateUrl(url) {
    const regexp = /((https?\:\/\/)|(www\.))(\S+)(\w{2,4})(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/g;

    if (url === '') {
      return true;
    }

    if (url.match(regexp)) {
        return true;
      } else {
        swal(
          'Invalid Url!',
          'URL:' + url,
          'error'
        );
      return false;
    }
  }

  startTour() {
    const intro = introJs();

    intro.setOption('hidePrev', true);
    intro.setOption('hideNext', true);
    intro.setOption('disableInteraction', true);
    intro.setOption('exitOnOverlayClick', false);
    intro.setOption('overlayOpacity', '0.5');

    intro.start();
  }

  onSyncAgents() {
    if (this.authUser._tmp === '1') {
      swal(
        'Temporary Account Access',
        'Such Priviledge is not allowed',
        'error'
      );

      return;
    }

    const $this = this;
    swal({
      html: true,
      title: 'Are you sure you want to sync all the office agents?',
      text: 'This will fetch all office agent profile and update them. <br>This action mate take a while to complete.',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Proceed'
    }).then(function () {
      $this.loading = true;
      if ( $this.authUser.provider === 'mydesktop' ) {
        $this.mydesktopService.httpSyncAgents($this.user.client_id);
      } else {
        $this.vaultService.httpSyncAgents($this.user.client_id);
      }
    }).catch(swal.noop);
  }

  onAgencySubmit() {
    const agencyValues = this.agencyForm.value;
    const lockFields = $('[name="field[]"]:checked').map(function () {
      return this.value;
    }).get();

    agencyValues['locked_fields'] = lockFields;
    agencyValues['agent_page'] = 'yes';

    this.clientService.httpPutClient(this.client.ID, agencyValues);
  }

  checkLockFields() {
    this.loading = true;
    this.clientService.httpGetClientLockFields(this.client.ID);
  }

  isLocked(fieldName) {
    return ( this.lockFields.includes(fieldName) ? true : null);
  }

}



// WEBPACK FOOTER //
// ./src/app/front/settings/settings.component.ts